import { css } from "lit";
import { signal } from "@lit-labs/preact-signals";
import { debounce } from "../helpers/debounce.js";
const breakpoints = {
  desktopXxl: 1400,
  desktopXl: 1280,
  desktop: 992,
  tablet: 768,
  mobile: 576
};
const _dsfDevice = signal(getDeviceSize());
const dsfDevice = _dsfDevice;
const isMobile = () => dsfDevice.value === "mobile";
const isTablet = () => dsfDevice.value === "tablet";
const isDesktop = () => dsfDevice.value === "desktop";
const isDesktopXl = () => dsfDevice.value === "desktopXl";
const isDesktopXxl = () => dsfDevice.value === "desktopXxl";
function getViewportWidth() {
  var _a;
  return ((_a = window.visualViewport) == null ? void 0 : _a.width) || window.innerWidth;
}
function getDeviceSize(vieportWidth = getViewportWidth()) {
  if (vieportWidth <= breakpoints.mobile)
    return "mobile";
  if (vieportWidth <= breakpoints.desktop)
    return "tablet";
  if (vieportWidth >= breakpoints.desktopXxl)
    return "desktopXxl";
  if (vieportWidth >= breakpoints.desktopXl)
    return "desktopXl";
  return "desktop";
}
const mediaQueries = {
  mobile: {
    up: (style) => css`
      @media only screen and (min-width: ${breakpoints.mobile}px) {
        ${style};
      }
    `,
    down: (style) => css`
      @media only screen and (max-width: ${breakpoints.mobile}px) {
        ${style};
      }
    `
  },
  tablet: {
    up: (style) => css`
      @media only screen and (min-width: ${breakpoints.tablet}px) {
        ${style};
      }
    `,
    down: (style) => css`
      @media only screen and (max-width: ${breakpoints.tablet}px) {
        ${style};
      }
    `
  },
  desktop: {
    up: (style) => css`
      @media only screen and (min-width: ${breakpoints.desktop}px) {
        ${style};
      }
    `,
    down: (style) => css`
      @media only screen and (max-width: ${breakpoints.desktop}px) {
        ${style};
      }
    `
  }
};
const registerDeviceListener = () => {
  if (!window.DSF_DEVICE_LISTENER_INITIALIZED) {
    const debounceId = Math.random().toString();
    window.addEventListener(
      "resize",
      () => debounce(() => _dsfDevice.value = getDeviceSize(), 100, debounceId)
    );
    window.DSF_DEVICE_LISTENER_INITIALIZED = true;
  }
};
export {
  breakpoints,
  dsfDevice,
  getDeviceSize,
  isDesktop,
  isDesktopXl,
  isDesktopXxl,
  isMobile,
  isTablet,
  mediaQueries,
  registerDeviceListener
};
